import React, { useState, useEffect } from "react";
import {
  Card, CardContent, Grid, Typography, Divider,
  TextField, Button, MenuItem, FormControl, InputLabel, Select
} from "@mui/material";
import EntitySelector from "../components/EntitySelector";
import SummaryStats from "../components/SummaryStats";
import FinancialChart from "../components/FinancialChart";
import SummaryStatsChart from "../components/SummaryStatsChart";
import NewsSummaryCard from "../components/NewsSummaryCard";

export default function Dashboard() {
  const [entity, setEntity] = useState("AAPL");
  const [availableMetrics, setAvailableMetrics] = useState([]);
  const [summaryMetrics, setSummaryMetrics] = useState([]);
  const [summaryMetric, setSummaryMetric] = useState("");
  const [selectedMetric, setSelectedMetric] = useState("");
  const [selectedMetrics, setSelectedMetrics] = useState([]);
  const [period, setPeriod] = useState("1Y");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/financials/${entity}`)
      .then(res => res.json())
      .then(data => {
        const uniqueMetrics = Array.from(new Set(data.map(row => row.Metric)));
        const topMetrics = uniqueMetrics.slice(0, 10); // limit to top 10
        setAvailableMetrics(topMetrics);
        setSelectedMetrics(topMetrics.slice(0, 2));
        setSummaryMetrics(topMetrics); // can hardcode later
        setSummaryMetric(topMetrics[0]);
        setSelectedMetric(topMetrics[0]);

      });
  }, [entity]);

  const handleDownload = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/financials/${entity}`)
      .then(res => res.json())
      .then(data => {
        if (!data.length) return;
        const headers = Object.keys(data[0]);
        const csv = [
          headers.join(","),
          ...data.map(row =>
            headers.map(field =>
              `"${String(row[field] ?? "").replace(/"/g, '""')}"`
            ).join(",")
          )
        ].join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${entity}_financials.csv`;
        a.click();
      });
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <EntitySelector value={entity} onChange={setEntity} />

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Chart Metric</InputLabel>
              <Select
                value={selectedMetric}
                label="Chart Metric"
                onChange={(e) => setSelectedMetric(e.target.value)}
              >

                {availableMetrics.map((metric) => (
                  <MenuItem key={metric} value={metric}>
                    {metric}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Period</InputLabel>
              <Select
                value={period}
                label="Period"
                onChange={(e) => setPeriod(e.target.value)}
              >
                {["1Q", "2Q", "3Q", "1Y", "3Y", "5Y"].map(p => (
                  <MenuItem key={p} value={p}>{p}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <Button variant="outlined" onClick={handleDownload} sx={{ mt: 2 }}>
              Download CSV
            </Button>
          </CardContent>
        </Card>
      </Grid>
      
      
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Summary Stats</Typography>
            <Divider sx={{ mb: 2 }} />
            <SummaryStats entity={entity} filterMetrics={summaryMetrics} />
          </CardContent>
        </Card>
      </Grid>
        
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Time Series Chart</Typography>
            <Divider sx={{ mb: 2 }} />
            {selectedMetric ? (
              <FinancialChart
                entity={entity}
                selectedMetrics={[selectedMetric]}
                period={period}
              />
            ) : (
              <Typography color="text.secondary">
                Loading metric chart...
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
    
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6">Summary Metric Chart</Typography>
            <Divider sx={{ mb: 2 }} />
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Summary Metric</InputLabel>
              <Select
                value={summaryMetric}
                label="Summary Metric"
                onChange={(e) => setSummaryMetric(e.target.value)}
              >
                {availableMetrics.map((metric) => (
                  <MenuItem key={metric} value={metric}>{metric}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <SummaryStatsChart
              entity={entity}
              metric={summaryMetric}
              period={period}
            />
          </CardContent>
        </Card>
      </Grid>
        
      <Grid item xs={12} md={6}>
        <Card sx={{ mt: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>🧠 Company News Summary</Typography>
            <NewsSummaryCard entity={entity} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}